import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

const CutPanelInspectionEndPoints = {
  FETCH_CUT_PANEL_INSPECTION_INFO: 'FETCH_CUT_PANEL_INSPECTION_INFO',
  FETCH_COMPONENT_TAG_DETAILS: 'FETCH_COMPONENT_TAG_DETAILS',
  FETCH_COMPONENTS_LIST_BY_MASTER_TAG: 'FETCH_COMPONENTS_LIST_BY_MASTER_TAG',
  FETCH_COMPONENTS_LIST_BY_MASTER_TAG_CPM: 'FETCH_COMPONENTS_LIST_BY_MASTER_TAG_CPM',
  UPDATE_INSPECTION_INFO: 'UPDATE_INSPECTION_INFO',
  SAVE_INSPECTION_DETAILS: 'SAVE_INSPECTION_DETAILS',
  COMPLETE_INSPECTION: 'COMPLETE_INSPECTION',
  FETCH_ALL_TRANSACTIONS_DATA: 'FETCH_ALL_TRANSACTIONS_DATA',
  FETCH_COMPONENT_TAG_DETAILS_WITH_WIP_INFO: 'FETCH_COMPONENT_TAG_DETAILS_WITH_WIP_INFO',
};

type TCutPanelInspectionEndPoints = typeof CutPanelInspectionEndPoints;
type TCutPanelInspectionEndPointsTypes = keyof TCutPanelInspectionEndPoints;
type TEnvVariables = TCutPanelInspectionEndPoints;

@Injectable({
  providedIn: 'root',
})
export class CutPanelInspectionEnvProvider {
  private env_vars!: TEnvVariables;
  private protocol = 'http';
  private service_host = '';
  private tags_services = '';

  constructor(@Inject('environment') ENV: TInputAppEnvironmentVars) {
    if (ENV.protocol !== null) {
      this.protocol = ENV.protocol;
    }
    if (ENV.service_host !== null) {
      this.service_host = ENV.service_host;
    }
    if (ENV.tags_services !== null) {
      this.tags_services = ENV.tags_services;
    }
    this.registerVars();
  }

  registerVars() {
    const HOST_DOMAIN_WITH_PROTOCOL = this.protocol + this.service_host;
    const TAGS_SERVICE_URL = HOST_DOMAIN_WITH_PROTOCOL + this.tags_services;

    this.env_vars = {
      FETCH_CUT_PANEL_INSPECTION_INFO: `${TAGS_SERVICE_URL}/cpi/v1/inspection-info/count/get`,
      FETCH_COMPONENT_TAG_DETAILS: `${TAGS_SERVICE_URL}/tags/getComponentTagByDisplayTagId`,
      FETCH_COMPONENTS_LIST_BY_MASTER_TAG: `${TAGS_SERVICE_URL}/tags/getCutBundleComponentTagsByCutDisplayTagId`,
      FETCH_COMPONENTS_LIST_BY_MASTER_TAG_CPM: `${TAGS_SERVICE_URL}/tags/getCutBundleCPIComponentTagsByCutDisplayTagId`,
      UPDATE_INSPECTION_INFO: `${TAGS_SERVICE_URL}/cpi/v1/inspection-info/update`,
      SAVE_INSPECTION_DETAILS: `${TAGS_SERVICE_URL}/cpi/v1/inspection-info/save`,
      COMPLETE_INSPECTION: `${TAGS_SERVICE_URL}/cpi/v1/inspection-info/complete`,
      FETCH_ALL_TRANSACTIONS_DATA: `${TAGS_SERVICE_URL}/cpi/v1/inspection-info/get`,
      FETCH_COMPONENT_TAG_DETAILS_WITH_WIP_INFO: `${TAGS_SERVICE_URL}/cpm/api/getComponentTagWipInfo`,
    };
  }

  getEnvVar(key: TCutPanelInspectionEndPointsTypes): string {
    return this.env_vars[key];
  }
}
